import * as React from 'react'
import { IsMobileContext } from '../../common/Context'
import { CheckboxProps, CheckboxState, ActionTypes, CheckboxActionTypes } from './types'
import Check from '../../images/check.svg'
import './style.scss'

const Checkbox: React.FC<CheckboxProps> = ({
  field,
  label,
  required,
  onChange,
  className,
  revalidate,
  children,
}) => {
  const { isMobile } = React.useContext(IsMobileContext)

  const checkboxInitialState: CheckboxState = {
    checked: false,
    isValid: !required,
    touched: false,
  }

  const checkboxReducer = (state: CheckboxState, action: CheckboxActionTypes) => {
    switch (action.type) {
    case ActionTypes.CHECKBOX_CHANGE:
      return {
        ...state,
        checked: action.checked,
        isValid: action.isValid,
        touched: true,
      }
    case ActionTypes.CHECKBOX_BLUR:
      return {
        ...state,
        touched: true,
      }
    default:
      return state
    }
  }

  const [checkboxState, dispatch] = React.useReducer(checkboxReducer, checkboxInitialState)

  React.useEffect(() => {
    if (revalidate) {
      dispatch({ type: ActionTypes.CHECKBOX_BLUR })
    }
  }, [revalidate])

  React.useEffect(() => {
    if (checkboxState.touched) {
      onChange(field, checkboxState.checked, checkboxState.isValid)
    }
  }, [checkboxState, onChange, field])

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked
    const isValid = required ? checked : true
    dispatch({ type: ActionTypes.CHECKBOX_CHANGE, checked, isValid })
  }

  const checkSize = isMobile ? '4vw' : '1vw'
  const validatedError = !checkboxState.isValid && checkboxState.touched

  return (
    <div className={`Checkbox FontS ${className || ''}`}>
      <input
        id={field}
        type="checkbox"
        className="h-0 w-0 opacity-0"
        checked={checkboxState.checked}
        required={required} 
        onChange={changeHandler}
      />
      <div className="w-full inline-flex items-start">
        <label 
          htmlFor={field}
          className={`
            inline-block border border-black box-content flex-shrink-0 cursor-pointer
            w-mobile-xs lg:w-xs h-mobile-xs lg:h-xs mr-mobile-xs lg:mr-xs
            ${checkboxState.checked ? 'border-primary bg-primary' : ''}
            ${validatedError ? 'border-accent' : ''}
          `}
          style={{marginTop: isMobile ? 'calc(1vw - 1px)' : 'calc(0.25vw - 1px)'}}
        >
          {checkboxState.checked && <Check style={{width: checkSize, height: checkSize}} />}
        </label>
        <div className="w-full relative">
          {label || children}
        </div>
      </div>
    </div>
  )
}

export default Checkbox
